export default __webpack_public_path__ + "static/media/candidate.work_learn_tab.baking.b848a9b6.jpg";